import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import './styles.css';

const BasicAccordion = props => {
  const {
    title,
    selected,
    children,
    isToggled,
    toggleIndex,
    toggledIndex,
    toggleFunc,
  } = props;
  const [toggled, setToggle] = useState(isToggled || false);

  useEffect(() => {
    if (toggleIndex === toggledIndex && !toggled) {
      setToggle(true);
    } else if (toggleIndex !== toggledIndex) {
      setToggle(false);
    }
  }, [toggledIndex]);

  const toggleHandler = () => {
    setToggle(!toggled);
    toggleFunc(toggleIndex);
  };

  const chevron = toggled ? (
    <FontAwesomeIcon icon={faChevronUp} color="#f40" size="sm" />
  ) : (
    <FontAwesomeIcon icon={faChevronDown} color="#f40" size="sm" />
  );

  const clsCaptonSelected =
    selected || isToggled ? ' basic-accordion__caption--selected' : '';
  const clsCaption =
    (toggled
      ? 'basic-accordion__caption basic-accordion__caption--toggled'
      : 'basic-accordion__caption') + clsCaptonSelected;

  const clsBody = toggled
    ? 'basic-accordion__body basic-accordion__body--open'
    : 'basic-accordion__body';

  return (
    <div className="basic-accordion">
      <div onClick={toggleHandler} className={clsCaption}>
        {title}
        <span className="basic-accordion__icon">{chevron}</span>
      </div>
      <div className={clsBody}>{children}</div>
    </div>
  );
};

export default BasicAccordion;
